<template>
  <div id="manage">
    <menu-default/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-gears"></i>  Gerenciador de publicações</h1>
            <p class="text-center" v-show="signatures.length > 0"><a href="#" @click="downloadCert"><i class="fa fa-certificate"></i> Baixar Certificado</a></p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div v-show="!logged" class="w-100">
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Você precisa estar logado</h4>
            <p>Para gerenciar as publicações que adquiriu, você precisa fazer login no sistema.</p>
            <hr>
            <p class="mb-0"><button class="btn btn-outline-primary" @click="redirectURL({name: 'login'})">Faça seu login agora</button></p>
          </div>
        </div>

        <div v-show="logged && !loading" class="w-100">

          <div v-show="signatures.length < 1" class="w-100">
            <div class="alert alert-light" role="alert">
              <h4 class="alert-heading">Nenhuma publicação encontrada</h4>
              <p>Você ainda não tem publicações contratadas para serem gerenciadas. </p>
              <hr>
              <p class="mb-0"><button class="btn btn-outline-primary" @click="redirectURL({name: 'publications'})">comprar uma publicação aqui</button></p>
            </div>
          </div>

            <div class="card w-100"  v-show="signatures.length >= 1">
              <div class="card-header">Minhas publicações </div>
              <ul class="list-group list-group-flush w-100">
                <li class="list-group-item" v-for="(signature, i) in signaturesList" :key="signature">
                  <div class="pull-right"><span :inner-html.prop="signature.status.id | nameStatusPublication"></span></div>

                  <h6>{{signature.publication.name}}</h6>
                  <small class="text-secondary">
<!--                    V.{{ signature.publication.version }} | {{ signature.publication.applicability }}-->
                      {{signature.active}}
                      <span v-show="signature.publication.is_signature">Assinatura até {{ signature.due | formatDate }}</span>
                    <span v-show="signature.publication.has_airplane_info">Prefixo: {{ signature.airplane_prefix }}</span>
                    <span v-show="signature.publication.has_airplane_info">| SN: {{ signature.airplane_serial_number }}</span>

                    <span class="pull-right text-right">
                      <a v-show="signature.overdue" href="#" @click="addProductToCart(signature.publication, false)">Comprar novamente</a>
                      <span v-show="signature.overdue">&nbsp;|&nbsp;</span>

                      <a v-show="signature.status.id === 1" v-bind:href="signature.file" target="_blank">Download</a>
                      <span v-show="signature.status.id === 1 && signature.publication.is_signature && !signature.overdue && signature.showRenew">&nbsp;|&nbsp;</span>

                        <div style="border:solid 1px #efefef; padding:5px; background: #FBFBFB" v-show="signature.publication.is_signature && !signature.overdue && signature.showRenew && signature.status.id !== 2">
                            <small>Renovar assinatura por R$ {{signature.publication.price_signature | formatPrice }}</small>
                            <div v-if="signature.renew_button_active">
                                  <button class="pull-right btn btn-add-to-cart" :class="signature.renew_button_active ? 'active':''" @click="removeProductToCart(signature.publication,i)">Remover do carrinho</button><br/>
                                </div>
                                <div v-else>
                                  <button class="pull-right btn btn-add-to-cart" :class="signature.renew_button_active ? 'active':''" @click="addProductToCart(signature.publication,i)">Adicionar ao carrinho</button><br/>
                                </div>
                            <a class="pull-right btn btn-buy text-right" style="paddin-right:1px" @click="goToCart()">Finalizar compra</a><br/>
<!-- <a  href="#" @click="addProductToCart(signature.publication, true)">Adicionar ao carrinho</a>-->
                        </div>

                      <div v-show="signature.status.id === 2">&nbsp;</div>
                    <span v-if="signature.order.expedition != null">
                      <div v-show="signature.status.id === 3">
                        <form id="track_correios" action="https://www2.correios.com.br/sistemas/rastreamento/ctrl/ctrlRastreamento.cfm" method="post" target="_blank">
                          <input name="P_LINGUA" value="001" type="hidden"><input name="P_TIPO" value="001" type="hidden">
                          <input name="objetos" id="objetos" type="hidden" :value="signature.order.expedition.track_code" >
                          <a onclick="$(this).parent().submit();" href="#">{{ signature.order.expedition.track_code }}</a>
                        </form>
                      </div>
                    </span>
                    </span>

                  </small>
                </li>
              </ul>
            </div>
          <div class="pagination pagination-medium pagination-right"  v-if="signatures.length > 0">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getSignatures(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getSignatures(next)">Próxima</a></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <footer-default/>
  </div>

</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import { mapState } from 'vuex'
  import mixins from "../helpers/mixins"
  import signature from '../api/signature'
  export default {
      name: "Manage",
      data() {
          return{
              signatures: [],
              loading: true,
              user: {email: ''}
          }
      },
      mixins: [mixins],
      computed: {
          ...mapState({
              'logged': state => state.logged,
              'cart': function(){ return this.$store.getters.getCart  }
          }),
          signaturesList() {
              return this.signatures.map((s) => {
                  let d = new Date();
                  d.setDate(d.getDate()+30)
                  let dd = new Date(s.due);

                  s.showRenew = dd < d
                  return s
              })
          }
      },
      components: { menuDefault, footerDefault },
      methods: {
          addProductToCart(product,i){
              this.signatures[i].renew_button_active = true
              if(product.price_signature !== 0) product.price = product.price_signature
              this.$store.dispatch('addProductToCart', product)

          },
          removeProductToCart(product,i){
              for(let cart_key in this.cart){
                  if(this.cart[cart_key]['id'] === this.signatures[i].publication['id']){
                      this.$store.commit('deleteFromCart', cart_key)
                      this.signatures[i].renew_button_active = false
                  }
              }
          },
          goToCart(){
              this.$router.push({name: 'cart'})
          },
          // addProductToCart(product, renew){
          //   if(renew){
          //     if(product.price_signature !== 0) product.price = product.price_signature
          //   }
          //   this.$store.dispatch('addProductToCart', product)
          //   this.$router.push({name: 'cart'})
          // },
          downloadCert(){
              signature.getCertificate().then(response => {
                  let blob = new Blob([response.data], { type: 'application/pdf' } )
                  let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(blob)
                  link.download = 'Certificate.pdf'
                  link.click()
              })
          },
          getSignatures(page){
              signature.list(page, this.$store.state.user.email).then((response)  =>  {
                  let cart = this.cart
                  for(let key in response.data.results) {
                      response.data.results[key].renew_button_active = false
                      cart.forEach(function(cartItem){
                          if(response.data.results[key].publication.id == cartItem.id || response.data.results[key].publication.renew_button_active){
                              response.data.results[key].renew_button_active = true
                          }
                      })
                  }

                  this.signatures = response.data.results
                  this.treatPagination(page, response.data.count, response.data.pages)
                  this.loading = false
              })
          }
      },
      watch: {
          user(newValue, oldValue) {
              if(this.$store.state.user.email !== undefined && newValue !== oldValue) {
                  this.getSignatures(1)
              }
          },
      },
      mounted(){
          this.user = this.$store.state.user
      }
  }
</script>

<style scoped>

</style>
